import {
  reactive,
  onBeforeMount,
  getCurrentInstance,
  watch,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import quizListModel from "@/models/survey-quiz/quiz-list";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import useModal from "@/@core/components/base-modal/hooks/useModal";

export default function useQuizDashborad() {
  const { fetchQueryDisplayDashboard } = quizListModel();

  const { openDefaultErrorModal } = useValidationModal();

  const { openModal, closeModal } = useModal();

  const dynamicDashboard = reactive({
    structure: {},
    dynamicConfig: {
      cardId: null,
      quizGroupId: null,
      questionId: null,
      key: null,
    },
    Quiz_GroupId: null,
    name: null,
    desc: null,
  });

  const fetchDashboardDisplay = (Quiz_GoupId) => {
    fetchQueryDisplayDashboard.payload.Quiz_GroupId = Quiz_GoupId;

    store
      .dispatch("api/apiRequest", fetchQueryDisplayDashboard)
      .then((response) => {
        dynamicDashboard.structure = response.data.layoutstructure;
        dynamicDashboard.name = response.data.info.name_html;
        dynamicDashboard.desc = response.data.info.desc_html;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {});
  };

  const modalPopup = reactive({
    report: false,
  });

  const onOpenExportModal = () => {
    modalPopup.report = true;
    openModal();
  };

  const closeReportModal = () => {
    modalPopup.report = false;
    closeModal();
  };
  onBeforeMount(() => {
    dynamicDashboard.Quiz_GroupId = parseInt(router.currentRoute.params.ref);
    fetchDashboardDisplay(dynamicDashboard.Quiz_GroupId);
  });

  return {
    dynamicDashboard,
    modalPopup,
    onOpenExportModal,
    closeReportModal,
  };
}
